package com.patronat.top.features.venues.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueAiImportResponse
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.command.ImportVenueWithAiCommand

class ImportVenueWithAiUseCase(
    private val venuesRepository: VenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ImportVenueWithAiCommand, DomainResult<VenueAiImportResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ImportVenueWithAiCommand): DomainResult<VenueAiImportResponse> {
        return venuesRepository.importVenueWithAi(command.request)
    }
}
